  <div [ngClass]="{ difuminar_Fondo: booCargando }">
    <h1 style="color: #003c8a;">Mis Compañías</h1>
    <hr>
    <div class="cards-container">
      <div class="card-row" *ngFor="let row of getRows(dataSource.data)">
        <div class="person-card" *ngFor="let companie of row" (click)="redirectDashboardClient(companie.companyId)">
          <div style="cursor: pointer;">
            <mat-chip class="custom-chip-name" style="pointer-events: none;"> 
              <span class="title_company">{{companie.companyName || 'Sin Nombre'}}</span>
            </mat-chip>
          </div>
          <div>
            <mat-chip class="custom-chip-rut" style="pointer-events: none;"> 
              <span class="title_rut">{{ companie.companyId | pipeClient: companie.dv }}</span>
            </mat-chip> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              <mat-chip *ngIf="companie.conectedSII === 0" class="custom-chip-sii-p" style="pointer-events: none;"> 
                <span class="title_sii">En Progreso</span>
              </mat-chip>
              <mat-chip *ngIf="companie.conectedSII === 1" class="custom-chip-sii-n" style="pointer-events: none;"> 
                <span class="title_sii">No Conectado</span>
              </mat-chip>
              <mat-chip *ngIf="companie.conectedSII === 2" class="custom-chip-sii-c" style="pointer-events: none;"> 
                <span class="title_sii">Conectado</span>
              </mat-chip>
          </div>
        </div>
      </div>
      <div *ngIf="dataSource.data.length === 0" style="text-align: center; width: 100%;">
        <mat-card class="cardWithShadow">
          <mat-card-content class="p-24">
            <h3>No hay Información</h3>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  